<template>
    <vue-table-card title="Flyers" :show-search-box="false" :fields="fields" :url="listUrl" :per-page="10" ref="table">
        <template #buttons>
            <btn color="success" icon="fa fa-plus" size="sm" @click="$refs.addModal.show()" text="Add"/>
        </template>

        <template #actions="{rowData}">
            <div class="btn-group-tight">
                <div>
                  <div v-if="rowData.disabled">
                    <btn class="btn-basic-b" color="danger" title=""
                         icon="fa fa-toggle-on"
                         @click="statusChange(rowData.id)">
                    </btn>
                  </div>
                  <div v-else>
                    <btn class="btn-basic-b" color="success" title=""
                         icon="fa fa-toggle-off"
                         @click="statusChange(rowData.id)">
                    </btn>
                  </div>
                </div>
                <btn class="btn-basic-b" text="" icon="fa fa-eye" @click="viewDetails(rowData)"/>
                <btn class="btn-basic-b" text="" icon="fa fa-pencil" @click="editDetails(rowData)"/>
                <btn class="btn-basic-b" color="danger" text="" icon="fa fa-trash" @click="setDelete(rowData)"/>
            </div>
        </template>
        <template #disabled="{rowData}">
            <p v-if="rowData.disabled">Yes</p>
            <p v-else>No</p>
        </template>

        <template #footer>
            <modal title="Add Flyer" ref="addModal" width="40r" header-color="primary" no-close-on-backdrop>
                <add-flyer @success="formSuccess"/>
            </modal>
             <modal title="Edit Flyer" ref="FlyerEditModal" width="40r" header-color="primary" no-close-on-backdrop>
                <edit-flyer :initial-data="editingItem" @success="formSuccess"/>
            </modal>
            <modal title="View Flyer" ref="FlyerViewModal" width="40r" header-color="primary" no-close-on-backdrop>
                <div class="row">
                  <div class="col-lg-12">
                    <validated-input disabled="true" v-model="viewItem.title" label="Title"></validated-input>
                  </div>

                  <div class="col-lg-6">
                      <validated-input disabled="true" v-model="viewItem.create_date" label="Created At"></validated-input>
                  </div>
                  <div class="col-lg-6">
                      <validated-input disabled="true" v-model="viewItem.updated_date" label="Updated At"></validated-input>
                  </div>
                    <div class="col-lg-6">
                    <btn size="sm" icon="fa fa-eye" type="button" title="Poster Front Side" @click="showPoster(viewItem.poster)"></btn>
                  </div>
                    <div class="col-lg-6"  v-if="viewItem.poster_2">
                    <btn size="sm" icon="fa fa-eye" type="button" title="Poster Back Side" @click="showPoster(viewItem.poster_2)"></btn>
                  </div>

                    <div class="col-lg-6">
                    <validated-check-box disabled="true" v-model="viewItem.disabled" label="Disabled"></validated-check-box>
                  </div>
                </div>

            </modal>
             <modal width="25r" title="Poster" ref="DetailimageModal" :noCloseOnBackdrop="true" :noCloseOnEsc="true" >
                <img :src="currentPoster" alt="Poster" style="max-width: 100%; height: auto;" />
              </modal>

            <delete-modal ref="deleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
                <p>You are about to delete the Item <b v-html="deletingItem && deletingItem.name"></b>. Are you sure ?
                </p>

                <template #loading>
                    <loading-animation/>
                    Please wait while we delete <b v-html="deletingItem && deletingItem.name"></b>.
                </template>
            </delete-modal>
        </template>

    </vue-table-card>
</template>

<script>
import urls from '../../../../data/urls';
import AddFlyer from './AddFlyer';
import EditFlyer from './EditFlyer';
import axios from 'secure-axios';

export default {
    name       : 'FlyersList',
    components : { AddFlyer, EditFlyer },
    data () {
        return {
            listUrl       : urls.admin.event.flyer.list,
            addUrl        : urls.admin.event.flyer.addEdit,
            deleteUrl     : urls.admin.event.flyer.delete,
            currentPoster : '',
            viewItem      : {
                title        : '',
                poster       : '',
                disabled     : false,
                create_date  : '',
                updated_date : ''
            },

            deletingItem : null,
            editingItem  : null,
            fields       : [
                {
                    name      : 'title',
                    sortField : 'title',
                    title     : 'Title'
                },
                {
                    name      : 'create_date',
                    sortField : 'create_date',
                    title     : 'Created At'
                },
                {
                    name      : 'updated_date',
                    sortField : 'updated_date',
                    title     : 'Updated At'
                },
                {
                    name  : '__slot:disabled',
                    title : 'Disabled'
                },
                {
                    name       : '__slot:actions',
                    titleClass : 'center aligned text-right',
                    dataClass  : 'aligned text-right'
                }
            ]
        };
    },
    methods : {
        showPoster (posterUrl) {
            this.currentPoster = posterUrl;
            this.$refs.DetailimageModal.show();
        },
        async statusChange (recId) {
            const response = await axios.form(urls.admin.event.flyer.status, { id : recId });
            const json = response.data;
            if (json.error === false) {
                this.$notify('Status Changed Successfully', 'Success', {
                    type : 'success'
                });
            } else {
                this.$notify('Could not change status', 'Error', {
                    type : 'danger'
                });
            }
            const refs = this.$refs;
            refs.table.refreshTable();
        },
        viewDetails (item) {
            this.viewItem = { ...item };
            this.$refs.FlyerViewModal.show();
        },
        editDetails (item) {
            this.editingItem = { ...item };
            this.$refs.FlyerEditModal.show();
        },
        formSuccess () {
            const refs = this.$refs;
            refs.addModal.close();
            refs.FlyerEditModal.close();
            refs.table.refreshTable();
            this.editingItem = null;
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.deleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$refs.deleteModal.close();
            this.$notify('Deleted Successfully', 'Success', {
                type : 'success'
            });
            this.$refs.table.refreshTable();
        }
    }
};
</script>

<style scoped>

</style>
